module.exports = __webpack_public_path__ + "img/provider-default.e9385b01.png";